<template>
  <div>
    <OffersTable>
      <template slot="title">{{ $t("LIST_OFFERS.SUB_TITLE") }}</template>
    </OffersTable>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import OffersTable from "@/views/partials/offers/OffersTable.vue";

export default {
  name: "ListOffers",
  components: {
    OffersTable,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t("LIST_OFFERS.TITLE") }]);
  },
};
</script>
